const overrides = (palette, typography) => ({
  root: {
    ...typography.body1,
    borderBottom: `1px solid ${palette.divider}`
  }
})

export default overrides
